<mat-form-field floatLabel="always">
    <mat-label
        >{{ Label }}<span *ngIf="Required" class="required">*</span></mat-label
    >
    <mat-chip-listbox
        #chipList
        [formControl]="TagControl"
        [selectable]="selectable"
    >
        <mat-chip
            *ngFor="let tag of selectedTags"
            [removable]="removable"
            (removed)="remove(tag)"
        >
            {{ tag }}
            <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
        </mat-chip>

        <input
            #tagInput
            matInput
            [formControl]="InputControl"
            [matAutocomplete]="auto"
            [matChipInputFor]="chipList"
            [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
            (matChipInputTokenEnd)="add($event)"
        />
        <mat-icon matSuffix>search</mat-icon>
    </mat-chip-listbox>
    <mat-hint>{{ Hint }}</mat-hint>
    <mat-autocomplete
        #auto="matAutocomplete"
        (optionSelected)="selected($event)"
        autoActiveFirstOption
    >
        <mat-option *ngFor="let tag of filteredTags | async" [value]="tag">
            {{ tag }}
        </mat-option>
    </mat-autocomplete>
</mat-form-field>

<mat-form-field
    *ngIf="isOtherTagSelected()"
    matTooltipPosition="right"
    matTooltipClass="tooltip"
    [ngClass]="'other-tag'"
>
    <mat-label>
        Provide text<span *ngIf="Required" class="required">*</span>
    </mat-label>
    <input matInput [type]="'text'" [formControl]="OtherTagControl" />
</mat-form-field>
